import * as v from 'valibot';
import { AnswerStateSchema } from './schema';
import type { AnswerState } from './types';

/**
 * Machine-readable error code returned by the session PUT endpoint when the
 * stored `funnel_config_version` differs from the currently served config.
 * The client keys on this to abandon the session and restart the flow.
 */
export const FUNNEL_CONFIG_VERSION_MISMATCH = 'funnel_config_version_mismatch';

export const SessionErrorBodySchema = v.object({
  code: v.optional(v.string()),
});

export const CreatedSessionSchema = v.object({
  session_id: v.pipe(v.string(), v.uuid()),
  answers: AnswerStateSchema,
});

export type CreatedSession = {
  session_id: string;
  answers: AnswerState;
};
